import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
declare var $ :any;
@Component({
	selector: 'home-work-social-tab',
	templateUrl: './tab.html',
	styleUrls: ['./tab.css']
})
export class HomeWorkSocialTab implements OnInit, AfterViewInit {

	@Input() tabList : any
	@Input() className : string
	@Input() tabNum : number
	@Output() onTabIndex = new EventEmitter<any>();


    ngOnInit() {
		
	}
		
	ngAfterViewInit(){
		if(this.tabNum == 0){
			$("#slide").addClass("left")
		}else if(this.tabNum == 1){
			$("#slide").addClass("right")
		}
	}

	tab(i){
		this.onTabIndex.emit(i)
		this.tabNum = i
		$("#slide").removeClass("left")
		$("#slide").removeClass("right")
		if(i===0){
			$("#slide").addClass("slide0")
			$("#slide").removeClass("slide1")
		}else if(i===1){
			$("#slide").addClass("slide1")
			$("#slide").removeClass("slide0")
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/app-home-work-show/home-work-social-tab/tab.ts